<mat-card>
    <mat-card-title>
        <span [translate]="'admin.parametres.api.soap.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset *ngIf="configurationSoap">
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="adresseUrl"
                                  name="adresseUrl"
                                  [(ngModel)]="configurationSoap.url"
                                  [rCol]="8"
                                  customType="input"
                                  libelle="admin.parametres.api.soap.adresseUrl">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="identifiant"
                                  name="identifiant"
                                  [(ngModel)]="configurationSoap.identifiant"
                                  [rCol]="3"
                                  customType="input"
                                  libelle="admin.parametres.api.soap.identifiant">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="password"
                                  name="password"
                                  [(ngModel)]="configurationSoap.password"
                                  [isPassword]="!isPasswordVisible"
                                  [rCol]="5"
                                  customType="input"
                                  libelle="admin.parametres.api.soap.password">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="passwordEncrypted"
                                  name="passwordEncrypted"
                                  [(ngModel)]="configurationSoap.passwordEncrypted"
                                  [isPassword]="!isPasswordVisible"
                                  [rCol]="5"
                                  customType="input"
                                  libelle="admin.parametres.api.soap.passwordEncrypted"
                                  [disabled]="true"
                                  [postTooltip]="'admin.parametres.api.soap.passwordEncryptedTooltip' | translate">
                    </custom-input>
                </div>
                <div class="row">
                    <div class="d-flex flex-row-reverse pb-2 pt-5">
                        <button mat-flat-button (click)="copyToClipboard()" color="primary" class="m-r-10" [disabled]="!configurationSoap.passwordEncrypted">
                            <span translate>admin.parametres.api.soap.copierMdp</span>
                        </button>
                        <button mat-stroked-button (click)="togglePasswordVisibility()" color="primary" class="m-r-10" [disabled]="!configurationSoap.passwordEncrypted">
                            <span *ngIf="!isPasswordVisible" translate>admin.parametres.api.soap.afficherMdp</span>
                            <span *ngIf="isPasswordVisible" translate>admin.parametres.api.soap.masquerMdp</span>
                        </button>
                    </div>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>
<floating-button [listeActions]="listeActions" *ngIf="listeActions"></floating-button>
